"use strict";

const debounce = (fn, time) => {
    let timeout;

    return function () {
        const functionCall = () => fn.apply(this, arguments);

        clearTimeout(timeout);
        timeout = setTimeout(functionCall, time);
    };
};

const isMobile = function () {
    return Modernizr.mq("(max-width: 767px)");
};

const isTablet = function () {
    return Modernizr.mq("(min-width: 768px)");
};

const isDesktop = function () {
    return Modernizr.mq("(min-width: 1024px)");
};

const isLargeDesktop = function () {
    return Modernizr.mq("(min-width: 1200px)");
};

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 */

// * t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing.jswing = jQuery.easing.swing;

jQuery.extend(jQuery.easing, {
    def: "easeOutQuad",
    easeOutExpo: function (x, t, b, c, d) {
        return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
    },
    easeInOutExpo: function (x, t, b, c, d) {
        if (t == 0) {
            return b;
        }

        if (t == d) {
            return b + c;
        }

        if ((t /= d / 2) < 1) {
            return (c / 2) * Math.pow(2, 10 * (t - 1)) + b;
        }

        return (c / 2) * (-Math.pow(2, -10 * --t) + 2) + b;
    },
});

const easeOutExpo = {
    duration: 500,
    easing: "easeOutExpo",
    queue: false,
};

const isEmpty = function (_str) {
    if (_str == "" || _str == null) {
        return true;
    } else {
        return false;
    }
};

const trimPipes = function (str) {
    if (str.indexOf("|") > -1) {
        return str.substring(str.indexOf("|") + 2);
    } else {
        return str;
    }
};

const removeFilterParams = function (str) {
    if (str.indexOf("-") > -1) {
        return str.substring(str.indexOf("-") + 1);
    } else {
        return str;
    }
};

const milOrBil = function (num) {
    let isBillion = num / 1000;
    let worth = num;

    if (isBillion >= 1) {
        worth = isBillion + "B";
    } else {
        worth = worth + "MM";
    }

    return worth;
};

const hasSection = function (data, arr) {
    for (let i = 0, l = data.length; i < l; i++) {
        if (trimPipes(data[i][1]) == arr[3]) {
            return true;
        }
    }

    return false;
};

const generateRows = function (params) {
    let htmlTpl = "";
    let data = params.data;
    let datum = data.datum;
    let arr = params.array;
    let numCol = params.data.numCol == undefined ? 2 : 3;

    if (numCol == 2) {
        for (let i = 0, l = datum.length; i < l; i++) {
            let dataArr = datum[i];

            if (
                trimPipes(dataArr[1]) == arr[3] &&
                trimPipes(dataArr[data.pos[1]]) !== ""
            ) {
                if (!isEmpty(dataArr[data.pos[0]])) {
                    htmlTpl += `<tr>`;

                    // * left column
                    if (data.toTrim[0]) {
                        if (data.pos.length == 3) {
                            htmlTpl += `<td>${trimPipes(
                                dataArr[data.pos[0]]
                            )} (${trimPipes(dataArr[data.pos[1]])})</td>`;
                        } else {
                            htmlTpl += `<td>${trimPipes(
                                dataArr[data.pos[0]]
                            )}</td>`;
                        }
                    } else {
                        if (data.pos.length == 3) {
                            htmlTpl += `<td>${
                                dataArr[data.pos[0]]
                            } (${trimPipes(dataArr[data.pos[1]])})</td>`;
                        } else {
                            htmlTpl += `<td>${dataArr[data.pos[0]]}</td>`;
                        }
                    }

                    // * right column
                    if (data.toTrim[1]) {
                        if (data.pos.length == 3) {
                            htmlTpl += `<td>${dataArr[data.pos[2]]}</td>`;
                        } else {
                            htmlTpl += `<td>${trimPipes(
                                dataArr[data.pos[1]]
                            )}</td>`;
                        }
                    } else {
                        if (data.pos.length == 3) {
                            htmlTpl += `<td>${dataArr[data.pos[2]]}</td>`;
                        } else {
                            htmlTpl += `<td>${dataArr[data.pos[1]]}</td>`;
                        }
                    }

                    htmlTpl += `</tr>`;
                }
            }
        }
    } else if (numCol == 3) {
        for (let i = 0, l = datum.length; i < l; i++) {
            let dataArr = datum[i];

            if (
                trimPipes(dataArr[1]) == arr[3] &&
                trimPipes(dataArr[data.pos[1]]) !== ""
            ) {
                if (!isEmpty(dataArr[data.pos[0]])) {
                    htmlTpl += `<tr>`;

                    // * left column
                    if (data.toTrim[0]) {
                        htmlTpl += `<td>${trimPipes(
                            dataArr[data.pos[0]]
                        )}</td>`;
                    } else {
                        htmlTpl += `<td>${dataArr[data.pos[0]]}</td>`;
                    }

                    // * middle column
                    if (data.toTrim[1]) {
                        if (isEmpty(dataArr[data.pos[2]].trim())) {
                            htmlTpl += `<td>${trimPipes(
                                dataArr[data.pos[1]]
                            )}</td>`;
                        } else {
                            htmlTpl += `<td>${trimPipes(
                                dataArr[data.pos[1]]
                            )}, ${dataArr[data.pos[2]]}</td>`;
                        }
                    } else {
                        if (isEmpty(dataArr[data.pos[2]].trim())) {
                            htmlTpl += `<td>${dataArr[data.pos[1]]}</td>`;
                        } else {
                            htmlTpl += `<td>${dataArr[data.pos[1]]}, ${
                                dataArr[data.pos[2]]
                            }</td>`;
                        }
                    }

                    htmlTpl += `    <td>${dataArr[data.pos[3]]}</td>`;

                    // * right column
                    if (data.toTrim[3]) {
                        htmlTpl += `<td>${trimPipes(
                            dataArr[data.pos[4]]
                        )}</td>`;
                    } else {
                        htmlTpl += `<td>${dataArr[data.pos[4]]}</td>`;
                    }

                    htmlTpl += `</tr>`;
                }
            }
        }
    }

    return htmlTpl;
};

const getCoordinatesFromArr = function (params) {
    let data = params.data;
    let arr = params.array;
    let newArr = [];

    if (params.type == "infrastructure") {
        for (let i = 0, l = data.length; i < l; i++) {
            let dataArr = data[i];

            if (
                trimPipes(dataArr[1]) == arr[3] &&
                Number(dataArr[5]) !== 0 &&
                Number(dataArr[6]) !== 0
            ) {
                newArr.push({
                    label: trimPipes(dataArr[2]),
                    type: {
                        label: trimPipes(dataArr[2]),
                        class: trimPipes(dataArr[2]).toLowerCase(),
                    },
                    country: {
                        label: trimPipes(dataArr[3]),
                        lat: Number(dataArr[5]),
                        long: Number(dataArr[6]),
                    },
                });
            }
        }
    } else if (params.type == "international") {
        for (let i = 0, l = data.length; i < l; i++) {
            let dataArr = data[i];

            if (
                trimPipes(dataArr[1]) == arr[3] &&
                Number(dataArr[3]) !== 0 &&
                Number(dataArr[4]) !== 0
            ) {
                newArr.push({
                    label: "",
                    type: {
                        label: "International Investment",
                        class: "international",
                    },
                    country: {
                        label: trimPipes(dataArr[2]),
                        lat: Number(dataArr[3]),
                        long: Number(dataArr[4]),
                    },
                });
            }
        }
    } else if (params.type == "research") {
        for (let i = 0, l = data.length; i < l; i++) {
            let dataArr = data[i];

            if (
                trimPipes(dataArr[1]) == arr[3] &&
                Number(dataArr[3]) !== 0 &&
                Number(dataArr[4]) !== 0
            ) {
                newArr.push({
                    label: dataArr[5],
                    type: {
                        label: "Research Investment",
                        class: "research",
                    },
                    country: {
                        label: trimPipes(dataArr[2]),
                        lat: Number(dataArr[3]),
                        long: Number(dataArr[4]),
                    },
                });
            }
        }
    }

    return newArr;
};

const countItems = function (data, param, columnNum) {
    // * Preparing for counting
    let countArr = [];

    data.forEach((el, i) => {
        if (i == 0) {
            return false;
        }

        let val = trimPipes(el[1]).toLowerCase();

        if (val == param && !isEmpty(val)) {
            countArr.push(trimPipes(el[columnNum]));
        }
    });

    // * Counting the duplicates
    return countForDuplicates(countArr);
};

const countEverything = function (data, columnNum, param = null) {
    // * Preparing for counting
    let countArr = [];

    data.forEach((el, i) => {
        if (i == 0) {
            return false;
        }

        let val = trimPipes(el[1]).toLowerCase();
        if (!isEmpty(val) & !isEmpty(el[columnNum])) {
            if (param == null) {
                countArr.push(trimPipes(el[columnNum]));
            } else {
                countArr.push(param);
            }
        }

        if (!isEmpty(val) & !isEmpty(el[columnNum + 1])) {
            if (param == null) {
                countArr.push(trimPipes(el[columnNum + 1]));
            } else {
                countArr.push(param);
            }
        }
    });

    // * Counting the duplicates
    return countForDuplicates(countArr);
};

const countForDuplicates = function (arr) {
    arr.sort();
    let current = null;
    let cnt = 0;
    let finalCount = [];

    arr.forEach((el, i) => {
        if (arr[i] != current) {
            if (cnt > 0) {
                finalCount.push({
                    label: current,
                    value: cnt,
                });
            }

            current = arr[i];
            cnt = 1;
        } else {
            cnt++;
        }
    });

    if (cnt > 0) {
        // * console.log(current + ' comes --> ' + cnt + ' times');
        finalCount.push({
            label: current,
            value: cnt,
        });
    }

    return finalCount;
};

const removeDuplicates = function (arr) {
    let unique_array = arr.filter(function (elem, index, self) {
        return index == self.indexOf(elem);
    });

    return unique_array;
};

const removeDuplicateMarkers = function (array, key) {
    return array.filter(
        (obj, index, self) =>
            index === self.findIndex((el) => el[key] === obj[key])
    );
};

const convertToClass = function (str) {
    let _str = str.trim();

    if (
        _str == "5G relationship" ||
        _str == "5g relationship" ||
        _str == "5g-relationship"
    ) {
        _str = "relationship";
    }

    if (_str == "R&D lab" || _str == "r&d lab" || _str == "r&d-lab") {
        _str = "rnd lab";
    }

    return _str.replace(/[ &\/\\#,+()$~%.'":*?<>{}]/g, "-").toLowerCase();
};

const sanitize = function (str) {
    return str.toLowerCase().replace(/[ ()\[\]']/g, "-");
};

const getDefaultCoord = function (params) {
    for (let i = 0, l = params.model.countriesModel.length; i < l; i++) {
        let countriesModel = params.model.countriesModel;

        if (countriesModel[i][1] == params.country && params.type == "lat") {
            return Number(countriesModel[i][2]);
        } else if (
            countriesModel[i][1] == params.country &&
            params.type == "lng"
        ) {
            return Number(countriesModel[i][3]);
        }
    }
};

const createLinks = function (text, new_window) {
    const url_pattern =
        /(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?/gi;
    let target = new_window === true || new_window == null ? "_blank" : "";

    return text.replace(url_pattern, function (url) {
        let protocol_pattern = /^(?:(?:https?|ftp):\/\/)/i;
        let href = protocol_pattern.test(url) ? url : "http://" + url;
        return '<a href="' + href + '" target="' + target + '">' + url + "</a>";
    });
};

const isTrueOrFalse = function (boolean) {
    if (boolean === "TRUE") {
        return true;
    } else if (boolean === "FALSE") {
        return false;
    }
};

const getOS = function () {
    let userAgent = window.navigator.userAgent;
    let platform = window.navigator.platform;
    let macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
    let windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
    let iosPlatforms = ["iPhone", "iPad", "iPod"];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = "Windows";
    } else if (/Android/.test(userAgent)) {
        os = "Android";
    } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
    }

    return os;
};

const truncateString = function (str, num) {
    return str.length < num
        ? str
        : `${str.substr(0, str.substr(0, num - 3).lastIndexOf(" "))}...`;
};

export {
    debounce,
    isMobile,
    isTablet,
    isDesktop,
    isLargeDesktop,
    easeOutExpo,
    isEmpty,
    trimPipes,
    removeFilterParams,
    milOrBil,
    hasSection,
    generateRows,
    getCoordinatesFromArr,
    countItems,
    countEverything,
    countForDuplicates,
    removeDuplicates,
    removeDuplicateMarkers,
    convertToClass,
    sanitize,
    getDefaultCoord,
    createLinks,
    isTrueOrFalse,
    getOS,
    truncateString,
};
